const $ = require('jquery');
const { amplify } = require('amplify');

$(function () {
	$(".header-idioma a").click(function (event) {
		event.preventDefault();
		if ($(this).closest('li').hasClass('active')) {
			event.stopPropagation();
			return false;
		}
		var locale = $(this).data('locale');
		var localeForm = $('#localeForm');
		if (!localeForm.length) {
			$('body').append('<form id="localeForm"><input type="hidden" name="locale" value=""></form>');
		}
		amplify.publish('locale.before-change', { locale: locale });
		$('#localeForm input[name=locale]').val(locale);
		$('#localeForm').submit();
	});
});



// WEBPACK FOOTER //
// ./js/aemps/header.js